module.exports = {
	hooks: {
		attach: function($element, options){}
	}
};